import React, { Component } from 'react';
import {
  BrowserRouter,
  Routes,
  Route,Navigate
} from "react-router-dom";
import { connect } from 'react-redux';

const PrivateRouter  =({component :Component,auth,...rest }) =>{
//   let enableSkip = localStorage.getItem("enableSkip");
//   if(!auth.isAuthenticated){
//     let path  = window.location.pathname;
//     if(path != '/auth'){
//       localStorage.setItem("lastPath",window.location.pathname)
//     }
//   }
  return (<Route {...rest} render={(props) => (
    auth.isAuthenticated === true
      ?  <Component {...props} /> 
      :  <Navigate to={{
                    pathname: '/',
                    state: { from: props.location }
                }}
              />
  )} />)


    

              }


const mapStateToProps = state =>({
  auth:state.auth
});

export default connect(mapStateToProps,null)(PrivateRouter);